export const timePatternOptions = [
    { pattern: "24h", display: "21:50" },
    { pattern: "12h", display: "09:50PM" },
]